import "/opt/buildhome/repo/sentry.client.config.ts";
import { init } from 'astro/virtual-modules/prefetch.js';init()